import {
  formatNumber,
  formatCurrency as uiFormatCurrency
} from '@blockanalitica/ui';

export function formatCurrency(value: number, currency = 'USD') {
  const maximumFractionDigits = Math.abs(value) < 0.01 ? 5 : 2;

  if (currency === 'USD') {
    return uiFormatCurrency(value, {
      maximumFractionDigits: maximumFractionDigits,
      currency: currency
    });
  }

  const formatted = formatNumber(value, {
    maximumFractionDigits: maximumFractionDigits
  });

  return `${formatted} ${currency}`;
}

export function makeSeries(seriesCount: number, points: number) {
  const series = Array.from({ length: seriesCount }, () => {
    let lastValue = Math.max(250, Math.floor(Math.random() * 3000));

    return {
      data: Array.from({ length: points }, (_, i) => {
        const date = new Date();
        date.setDate(date.getDate() - i);

        // Small random change
        const change = (Math.random() - 0.5) * 100;

        // Occasionally introduce a larger change
        if (Math.random() < 0.2) {
          // 10% chance of a larger change
          lastValue += change * 5; // Adjust the multiplier for larger changes
        } else {
          lastValue += change;
        }

        // Ensure value stays within a reasonable range
        lastValue = Math.max(250, Math.min(lastValue, 3000));

        return {
          date: date.toISOString().split('T')[0],
          value: lastValue,
          value_usd: lastValue * 1000
        };
      }).reverse()
    };
  });

  // TODO: Enable this once Charts support multiple series
  // Return only the data array if seriesCount is 1
  // return seriesCount === 1 ? series[0].data : series;

  return series[0].data;
}
export function hexToRgb(hex: string, alpha?: number) {
  hex = hex.replace(/^#/, '');

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  const a = alpha ?? 1;

  return { r, g, b, a };
}
export function transformString(str: string): string {
  const specialWords = ['USDC', 'SKY', 'DAI', 'MKR', 'USDS'];
  const connectingWords = ['to'];

  return str
    .split('-')
    .map((word) => {
      // Check if the word (in uppercase, for case-insensitive comparison) is in the list of special words
      if (specialWords.includes(word.toUpperCase())) {
        return word.toUpperCase(); // Convert the entire word to uppercase
      } else if (connectingWords.includes(word.toLowerCase())) {
        return word.toLowerCase(); // Convert the entire word to lowercase
      } else {
        // Capitalize the first letter of the word and leave the rest as is
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
    })
    .join(' ');
}

export function trendVariantInverted(value: number): string | undefined {
  if (value > 0) {
    return 'bear';
  }
  if (value < 0) {
    return 'bull';
  }
  return undefined;
}

export function generateGradientColor(baseColor, index, total) {
  if (index === 0) {
    return baseColor;
  }
  const rgb = parseInt(baseColor.slice(1), 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = rgb & 0xff;

  const lightnessFactor = 0.3 + (index / total) * 0.8;

  const newR = Math.min(255, Math.round(r * lightnessFactor));
  const newG = Math.min(255, Math.round(g * lightnessFactor));
  const newB = Math.min(255, Math.round(b * lightnessFactor));

  return `rgb(${newR}, ${newG}, ${newB})`;
}
